export default __webpack_public_path__ + "static/media/icon_6_on.d507918a.png";